module.exports = __webpack_public_path__ + "static/media/4.b7b5e01b.jpg";